import React, { useState, useRef, useEffect } from 'react';
import { theme } from '../../config/theme';

const Dropdown = ({ 
  trigger, 
  children, 
  align = 'right',
  className = '' 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const containerStyles = {
    position: 'relative',
    display: 'inline-block',
  };

  const menuStyles = {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    [align]: 0,
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.gray[200]}`,
    borderRadius: theme.borderRadius.lg,
    boxShadow: theme.shadows.lg,
    minWidth: '200px',
    zIndex: theme.zIndex.dropdown,
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
    transform: isOpen ? 'translateY(0)' : 'translateY(-10px)',
    transition: 'all 0.2s ease',
  };

  return (
    <div ref={dropdownRef} className={className} style={containerStyles}>
      <div onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>
      <div style={menuStyles}>
        {children}
      </div>
    </div>
  );
};

export const DropdownItem = ({ children, onClick, icon, className = '' }) => {
  const itemStyles = {
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    cursor: 'pointer',
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.primary,
    transition: theme.transitions.fast,
  };

  return (
    <div
      className={className}
      style={itemStyles}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = theme.colors.gray[50];
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      {icon && <span>{icon}</span>}
      {children}
    </div>
  );
};

export default Dropdown;